// Mobile Ansicht (Handoff Dokumente §7): unter 900 px Breite oder unter 500 px Höhe; quer = breiter als hoch.

import { useEffect, useState } from 'react';

export interface MobilModus { mobil: boolean; quer: boolean; schmal: boolean }

export function mobilModus(breite: number, hoehe: number): MobilModus {
  const mobil = breite < 900 || hoehe < 500;
  return { mobil, quer: mobil && breite > hoehe, schmal: breite < 700 };
}

/** Bereiche, die schon die untere Leiste (MobileNav) statt des Menü-Knopfs nutzen. */
const MIT_MOBILE_NAV = ['/admin/dokumente', '/admin/emails', '/admin/zaehler', '/admin/tickets', '/admin/mieterselbstauskunft', '/admin/rechnungen', '/admin/zeiterfassung', '/admin/abwesenheiten', '/admin/personalakte', '/admin/monatsabschluss', '/admin/team', '/admin/super-admin', '/admin/profile', '/admin/dashboard', '/admin/kontakte/kontakt'];
// Nur genau dieser Pfad (nicht seine Unterseiten): Übergabe-Liste ja, Assistent nein — dort braucht die untere Leiste den Platz.
const MIT_MOBILE_NAV_EXAKT = ['/admin/uebergabeprotokolle', '/admin/kontakte', '/admin/schreiben'];
export const nutztMobileNav = (pfad: string) =>
  MIT_MOBILE_NAV.some(b => pfad === b || pfad.startsWith(`${b}/`)) || MIT_MOBILE_NAV_EXAKT.includes(pfad.replace(/\/$/, ''));

export function useMobilModus(): MobilModus {
  const lies = () => (typeof window === 'undefined' ? mobilModus(1280, 900) : mobilModus(window.innerWidth, window.innerHeight));
  const [m, setM] = useState<MobilModus>(lies);
  useEffect(() => {
    const neu = () => setM(alt => { const x = lies(); return x.mobil === alt.mobil && x.quer === alt.quer && x.schmal === alt.schmal ? alt : x; });
    window.addEventListener('resize', neu);
    window.addEventListener('orientationchange', neu);
    return () => { window.removeEventListener('resize', neu); window.removeEventListener('orientationchange', neu); };
  }, []);
  return m;
}
